<template>
    <div>
        <Editar v-if="showEditarItem" @fecharCardEditar="closeEditar" :dados="dadosEdicao" />
        
        <v-dialog v-model="dialogoListar" max-width="1000px" persistent>
            <v-card class="pa-4 white">
                <!-- Cabeçalho com título e botão de fechar -->
                <div class="dialog-header">
                    <v-btn text @click="close" class="close-btn">
                        <v-icon large color="red">clear</v-icon>
                    </v-btn>
                </div>

                <!-- Overlay para mostrar o carregamento -->
                <v-overlay :value="isLoadingFuncoes">
                    <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
                </v-overlay>

                <!-- Tabela com estilo melhorado -->
                <v-data-table :headers="headers" :items="funcoes" class="configuracoes-table" dense>
                    <!-- Índice do item -->
                    <template v-slot:item.index="{ item }">
                        <span>{{ funcoes.indexOf(item) + 1 }}</span>
                    </template>

                    <template v-slot:item.status="{ item }">
                        <v-chip :color="item.status === 1 ? 'green' : 'grey'" text-color="white">
                            {{ item.status === 1 ? 'Activo' : 'Desativado' }}
                        </v-chip>
                    </template>
                    <template v-slot:item.novo="{ item }">
                        <v-chip :color="item.novo === 1 ? 'green' : 'grey'" text-color="white">
                            {{ item.novo === 1 ? 'Sim' : 'Não' }}
                        </v-chip>
                    </template>

                    <!-- Menu de ações -->
                    <template v-slot:item.action="{ item }">
                        <v-menu bottom origin="center center" transition="scale-transition">
                            <template v-slot:activator="{ on }">
                                <v-btn fab dark color="#006699" class="action-btn" v-on="on">
                                    <v-icon>menu</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item @click="editarItem(item)">
                                    <v-icon color="#006699" small class="mr-2">edit</v-icon> Editar
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>
                </v-data-table>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from '../../plugins/axios';
import Swal from 'sweetalert2';
import Editar from './Editar.vue';
export default {
    props: ["menu"],
    data: () => ({
        isLoadingFuncoes: false,
        funcoes: [],
        dialogoListar: true,
        headers: [
            { text: "#", value: "index" },
            { text: "Descrição", value: "descricao" },
            { text: "Permissões", value: "niveis" },
            { text: "Novo", value: "novo" },
            { text: "Url", value: "url" },
            { text: "Autor da última actualização", value: "modifiedBy" },
            { text: "Data", value: "modifiedOn" },
            { text: "Status", value: "status" },
            { text: "Ação", value: "action" }
        ],
        dadosEdicao: null,
        showEditarItem: false,
        booleanItens: false
    }),

    components: {
        Editar
    },

    created() {
        this.carregarFuncoes();
    },

    methods: {
        async carregarFuncoes() {
            this.isLoadingFuncoes = true;
            try {
                let response = await axios.get(`/getItensByIdMenu/${this.menu.menu}`);
                this.funcoes = response.data;
            } catch (error) {
                Swal.fire('Informação', 'Erro ao carregar as funções do menu selecionado!', 'error');
            } finally {
                this.isLoadingFuncoes = false;
            }
        },

        editarItem(item) {
            this.dadosEdicao = item;
            this.showEditarItem = true;
            this.dialogoListar = false;
        },

        closeEditar(atualizar) {
            this.dialogoListar = true;
            this.showEditarItem = false;
            this.dadosEdicao = null;
            this.booleanItens = atualizar;
            if (atualizar) {
                this.carregarFuncoes();
            }
        },

        close() {
            this.$emit("fecharCardListar", this.booleanItens);
            this.dialogoListar = false;
        }
    }
};
</script>

<style></style>
